// Some browsers/webviews (strict privacy settings, in-app browsers, certain
// mobile Chrome configurations) throw a SecurityError when localStorage is
// accessed at all — not just return null. A direct `localStorage.getItem(...)`
// call in that case crashes the whole app. These wrappers swallow that error
// and fall back to "no value" / no-op, so the app degrades to a logged-out
// state instead of crashing.
export const safeStorage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (err) {
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (err) {
      return false;
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
      return true;
    } catch (err) {
      return false;
    }
  },
  clear: () => {
    try {
      localStorage.clear();
      return true;
    } catch (err) {
      return false;
    }
  },
};
